import { useState } from 'react';

import type { ChartTheme } from './types';

/** Chart.js's update mode for a render: `'none'` skips the animation, undefined animates. */
export type ChartUpdateMode = 'none' | undefined;

interface Seen {
    theme: ChartTheme;
    data: unknown;
    options: unknown;
    mode: ChartUpdateMode;
}

/**
 * `'none'` for the update a theme switch causes, so a chart takes the new colours with the
 * page instead of tweening them for most of a second after the crossfade; undefined (the
 * default animation) once the data or options change again.
 */
export function useChartUpdateMode(
    theme: ChartTheme,
    data: unknown,
    options: unknown
): ChartUpdateMode {
    const [seen, setSeen] = useState<Seen>({ theme, data, options, mode: undefined });
    if (seen.theme === theme && seen.data === data && seen.options === options) return seen.mode;
    const mode: ChartUpdateMode = seen.theme === theme ? undefined : 'none';
    setSeen({ theme, data, options, mode });
    return mode;
}
